import { API_ENDPOINTS } from "@/api/services/resourceAllocation/apiEndPoints";
import { baseApi } from "@/utils/baseApi";

export const ResourceAllocationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addAllocation: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.RM_ALLOCATION.ADD_ALLOCATION(),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["projectdata"],
    }),

    updateAllocation: builder.mutation({
      query: ({ id, ...data }) => ({
        url: API_ENDPOINTS.RM_ALLOCATION.UPDATE_ALLOCATION(id),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["projectdata"],
    }),
    rmOverallSubmit: builder.mutation({
      query: (action) => ({
        url: API_ENDPOINTS.RM_ALLOCATION.OVERALL_SUBMIT(action),
        method: "PUT",
      }),
      invalidatesTags: ["projectdata"],
    }),

    getEmployeeData: builder.query({
      query: () => ({
        url: API_ENDPOINTS.RM_ALLOCATION.GET_ALLOCATION(),
        method: "GET",
      }),
      providesTags: ["employeedetils"],
    }),
    getProjectData: builder.query({
      query: () => ({
        url: API_ENDPOINTS.RM_ALLOCATION.GET_ALLOCATED_PROJECT(),
        method: "GET",
      }),
      providesTags: ["projectdata"],
    }),
    getHrResourceList: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.HR_RESOURCE_LIST(params),
        method: "GET",
      }),
      providesTags: ["HrResourceList"],
    }),
    getDivisionHead: builder.query({
      query: () => ({
        url: API_ENDPOINTS.DIVISION_LIST(),
        method: "GET",
      }),
      providesTags: ["DivisionHead"],
    }),
    getReviewerByDH: builder.query({
      query: (divisionHeadId) => ({
        url: API_ENDPOINTS.REVIEWER_BY_DH(divisionHeadId),
        method: "GET",
      }),
    }),
    getRmByReviewer: builder.query({
      query: (reviewerId) => ({
        url: API_ENDPOINTS.RM_BY_REVIEWER(),
        method: "GET",
      }),
    }),
    getLeaveEmployee: builder.query({
      query: () => ({
        url: API_ENDPOINTS.NON_ELIGIBLE_EMPLOYEE(),
        method: "GET",
      }),
    }),
    getEmployeesByRm: builder.query({
      query: (reportingManagerId) => ({
        url: API_ENDPOINTS.EMPLOYEES_BY_RM(reportingManagerId),
        method: "GET",
      }),
    }),
    updateRmStatus: builder.mutation({
      query: ({ id, rmStatus }) => ({
        url: API_ENDPOINTS.UPDATE_RM_STATUS(id, rmStatus),
        method: "PUT",
      }),
      invalidatesTags: ["HrResourceList"],
    }),
    RAExportList: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.EXPORT(params),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { isExport: true },
    }),
  }),
});

export const {
  useAddAllocationMutation,
  useGetEmployeeDataQuery,
  useLazyGetEmployeeDataQuery,
  useGetProjectDataQuery,
  useGetHrResourceListQuery,
  useGetDivisionHeadQuery,
  useLazyGetReviewerByDHQuery,
  useLazyGetRmByReviewerQuery,
  useLazyGetEmployeesByRmQuery,
  useUpdateAllocationMutation,
  useRmOverallSubmitMutation,
  useUpdateRmStatusMutation,
  useLazyRAExportListQuery,
  useGetLeaveEmployeeQuery,
} = ResourceAllocationApi;
